const THEME_KEY = 'app_theme'

export function getThemeFromLocal() {
  try {
    return localStorage.getItem(THEME_KEY)
  } catch {
    return null
  }
}

export function saveThemeToLocal(theme) {
  try {
    localStorage.setItem(THEME_KEY, theme)
  } catch {
    // localStorage unavailable
  }
}

export function initTheme(store) {
  const cached = getThemeFromLocal()
  if (cached) {
    document.documentElement.setAttribute('data-theme', cached)
  }

  if (!cached && window.matchMedia) {
    const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
    const defaultTheme = prefersDark ? 'dark' : 'light'
    document.documentElement.setAttribute('data-theme', defaultTheme)
    store.dispatch('theme/switchTheme', defaultTheme)
  }

  if (window.matchMedia) {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
      if (!localStorage.getItem(THEME_KEY)) {
        store.dispatch('theme/switchTheme', e.matches ? 'dark' : 'light')
      }
    })
  }
}
